import React, { Component } from 'react'
import Webcam from "react-webcam";
import { connect } from "react-redux";
import { streamVideo } from "../Communaute.duck"
import imgWhite from "../../../../../styles/img/media-blue.svg"



const WebcamStreamCapture = ({ streamVideo, onCloseModalePhoto }) => {
  const webcamRef = React.useRef(null);
  const mediaRecorderRef = React.useRef(null);
  const [capturing, setCapturing] = React.useState(false);
  const [recordedChunks, setRecordedChunks] = React.useState([]);

  const handleStartCaptureClick = React.useCallback(() => {
    setCapturing(true);
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
      mimeType: "video/webm"
    });
    mediaRecorderRef.current.addEventListener(
      "dataavailable",
      handleDataAvailable
    );
    mediaRecorderRef.current.start();
  }, [webcamRef, setCapturing, mediaRecorderRef]);

  const handleDataAvailable = React.useCallback(
    ({ data }) => {
      if (data.size > 0) {
        setRecordedChunks((prev) => prev.concat(data));
      }
    },
    [setRecordedChunks]
  );

  const handleStopCaptureClick = React.useCallback(() => {
    mediaRecorderRef.current.stop();
    setCapturing(false);
    handleUpload()




  }, [mediaRecorderRef, webcamRef, setCapturing, handleUpload]);

  const handleUpload = React.useCallback(() => {
    if (recordedChunks.length) {
      const blob = new Blob(recordedChunks, {
        type: "video/mp4"
      });
      //A Blob() is almost a File() - it's just missing the two properties below which we will add
      blob.lastModifiedDate = new Date();
      blob.name = 'video';
      // const url = URL.createObjectURL(blob);
      // const a = document.createElement("a");
      // document.body.appendChild(a);
      // a.style = "display: none";
      // a.href = url;
      // a.download = "react-webcam-stream-capture.webm";
      // a.click();
      // window.URL.revokeObjectURL(url);
      // setRecordedChunks([]);




      streamVideo(blob)
      onCloseModalePhoto()

    }
  }, [recordedChunks]);
  const height = "100%"
  const width = "100%"
  const videoConstraints = {
    width: 1280,
    height: 600,
    facingMode: "user"
  };

  return (
    <>
      <Webcam
        audio={true}
        ref={webcamRef}
        // height={height}
        width={width}
        videoConstraints={videoConstraints} />
      <div className="d-flex justify-content-center "  >

        {capturing ? (

          <button className="btn-gradient   " onClick={handleStopCaptureClick}>Stop Capture</button>
        ) : (
            <button className="btn-gradient " onClick={handleStartCaptureClick}>Start Capture</button>
          )}
        {recordedChunks.length > 0 && (
           <div className="d-flex justify-content-center   " >
            <input type="file" className="d-none" id="add-media" />
            <label htmlFor="add-media" className="m-0 btn-white btn-border btn-label" onClick={handleUpload}><img src={imgWhite} class="img-fluid" alt="" /> Upload</label>
          </div>
        )}
      </div>

    </>
  );
};

const mapDispatchToProps = {
  streamVideo

};
export default connect(
  null,
  mapDispatchToProps
)(WebcamStreamCapture);

  // https://www.npmjs.com/package/react-webcam
